import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch, batch } from "react-redux"
import TopRoutes from '../../../../../stories/components/cars/SeoPage/TopRoutes/TopRoutesWrapper'
import { sourceSelector, destinationSelector, hrDefaultPackageSelector, hrDefaultPackageTimeSelector } from "../../../../common/redux/selector"
import { getSubtitleForAvailableCabs, getTitleForAvailableCabs } from '../../../../config/utils'
import useNavigate from '../../../../hooks/useNavigate'
import { UPDATE_PAYDATA, UPDATE_SELECTED_CAB } from '../../redux/seo-action-types'
import { UPDATE_HR_PACKAGE, UPDATE_HR_PACKAGE_TIME, UPDATE_TRIP_TYPE } from '../../../SearchPage/redux/action-types'
import { Hr, LOCAL_RENTAL, Rental } from '../../../../../shared/utils/util-constants'
import { PICKUP_LOC_DETAILS } from '../../../../../shared/config/constants'
import Popup from "../../../../../stories/core-components/PopupUI/PopupUI"

export default function({rentalData = []}) {
  const [errorMessage, setErrorMessage] = useState(null)
  const source                = useSelector(sourceSelector)
  const destination           = useSelector(destinationSelector)
  const hrDefaultPackage      = useSelector(hrDefaultPackageSelector)
  const hrDefaultPackageTime  = useSelector(hrDefaultPackageTimeSelector)
  const dispatch              = useDispatch()
  const [navigateTo]          = useNavigate()

  const parseRoutes = (routes) => { 
    if (routes && routes?.length > 0) {
      return routes.map((route) => {
        return {
          subtitle: route?.distance && route?.approx_time ? `${route?.distance} kms | ${route?.approx_time} (appx.)` : '',
          includedDistance: route?.included_distance ? `${route?.included_distance} kms included` : '',
          extraFare: route?.extra_fare && route?.distance ? `Extra fare ₹${route?.extra_fare}/km after ${route?.distance} kms` : '',
          startingPrice: route?.starting_price,
          car_types: route?.car_types || "",
          img_url: route?.img_url || "",
          vehicle_key: route?.vehicle_key || "",
          car_types_subtitle: route?.car_types_subtitle || "",
          d_s: route?.d_s || "",
          packageId: route?.packageId,
          packageTime: route?.packageTime,
          is_static: route?.is_static
        }
      })
    }
    return []
  }

  const onPackageChange = useCallback(()=>{
    if (source?.name) {
      dispatch({
        type: UPDATE_TRIP_TYPE,
        tripType: {
          name: LOCAL_RENTAL,
          rf: Hr
        }
      })
      navigateTo("srp", true);
    }else{
      const title = PICKUP_LOC_DETAILS?.title;
      const content = PICKUP_LOC_DETAILS?.error;
      setErrorMessage({ title, content });
    }
  }, [])

  const reviewAction = (route) => {
    batch(() => {
      dispatch({
        type: UPDATE_TRIP_TYPE,
        tripType: {
          name: LOCAL_RENTAL,
          rf: Hr
        }
      })
      dispatch({
        type: UPDATE_HR_PACKAGE,
        package_id: route?.is_static ? hrDefaultPackage : route?.packageId
      });
      dispatch({
        type: UPDATE_HR_PACKAGE_TIME,
        packageTime: route?.is_static ? hrDefaultPackageTime : route?.packageTime
      })
    })
    if (route?.is_static) {
      navigateTo('home')
    } else {
      dispatch({
        type: UPDATE_PAYDATA,
        paydata: {}
      })
      dispatch({
        type: UPDATE_SELECTED_CAB,
        selectedCab: { key: route?.vehicle_key, dispatchSearchId: '', vehicle_type: route?.key }
      })
      navigateTo('seo-to-review')
    }
  }

  return (
    <React.Fragment>
      <TopRoutes
        routes={parseRoutes(rentalData)}
        title={getTitleForAvailableCabs(Rental, source, destination)}
        onAction={(route) => reviewAction(route)}
        isCarType
        subtitle={getSubtitleForAvailableCabs(source?.name, destination?.name, 'Cab')}
        tableThirdColHeading={`${Rental ? getSubtitleForAvailableCabs(source?.name, destination?.name, 'Cab Price') : ''}`}
        showPackageCarousel={true}
        onPackageChange={onPackageChange}
      />
      {errorMessage && <Popup title={errorMessage?.title} content={errorMessage?.content} onCloseClick={() => setErrorMessage(null)} size='medium' />}
    </React.Fragment>
  )
}